import { GetPaymentMethodsParams, InitiateMoMoPaymentParams, InitiatePaymentParams } from "./interfaces/payments";
import { request } from "./utils";

const InitiatePublicPayment = (data: InitiatePaymentParams) => {
  return request("payments/initiate/public", "post", { data });
};

const InitiateMoMoPayment = (data: InitiateMoMoPaymentParams) => {
  return request("payments/zeepay-debit-wallet", "post", { data });
};

const GetPaymentMethods = (data: GetPaymentMethodsParams) => {
  return request("payments/public/payment-methods", "post", { data });
};

const CheckPaymentStatus = (data: { reference: string }) => {
  return request(`payments/status/${data.reference}`, "get");
};

export { InitiatePublicPayment, GetPaymentMethods, InitiateMoMoPayment, CheckPaymentStatus };
